
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateVHostForm from '@/services/Vhost/Origin/forms/CreateVHostForm';
import OriginVhostRepositoryInterface from '@/services/Vhost/Origin/Interfaces';
import { ServerInterface, ServerRepositoryInterface } from '@/services/Server/Interfaces';
import WebsiteRepositoryInterface, { Website } from '@/services/Website/interfaces';
import { SystemUserInterface, SystemUserRepositoryInterface } from '@/services/SystemUsers/interfaces';
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'originVhostRepository',
    'serverRepository',
    'websiteRepository',
    'systemUserRepository',
  ],
  components: {
    PageHeader,
  },
})
export default class CreateVHost extends Vue {
  private loading: boolean = true;
  private form: WPXFormValue<CreateVHostForm> = new WPXFormValue<CreateVHostForm>(CreateVHostForm);

  private originVhostRepository!: OriginVhostRepositoryInterface;
  private serverRepository!: ServerRepositoryInterface;
  private websiteRepository!: WebsiteRepositoryInterface;
  private systemUserRepository!: SystemUserRepositoryInterface;

  private servers: ServerInterface[] = [];
  private websites: Website[] = [];
  private systemUser!: SystemUserInterface;
  private systemUserName: string = '';

  private _websiteSearch: string = '';
  private websiteSearchLoading: boolean = true;

  private systemUsersPerPage: number = 10;
  private systemUsersPage: number = 1;
  private systemUserSearchLoading: boolean = true;

  private async created(): Promise<void> {
    await this.initialize();
    this.loading = false;
  }

  private async initialize(): Promise<void> {
    this.servers = await this.serverRepository.getAllServers();
  }

  private async addVhost(): Promise<void> {
    try {
      await this.originVhostRepository.createVhost({
        server: this.form.data.server,
        websiteId: this.form.data.websiteId,
        systemUserId: this.form.data.systemUserId,
      });

      this.$successDialog.show('Origin Vhost Creation Started!');
      await this.$router.push({ name: 'origin_vhost_list' });
    } catch (err) {
      this.$errorDialog.show(err.response?.data?.message || err.message);
    }
  }

  public get websiteSearch(): string {
    return this._websiteSearch;
  }

  public set websiteSearch(val: string) {
    if (val && val.length < 3) {
      return;
    }

    this._websiteSearch = `server=${this.form.data.server}&domain=${val}`;
    this.websiteSearchLoading = true;
    delete this.systemUser;
    this.websiteRepository.getByServerAndDomain(this.form.data.server, val).then((websites) => {
      this.websites = websites;
      this.websiteSearchLoading = false;
      this.systemUsersPage = 1;
      this.systemUserSearch();
    }).catch((err) => {
      this.$errorDialog.show(err.message);
    });
  }

  public async systemUserSearch(): Promise<void> {
    if (!this.form.data.websiteId) {
      return;
    }

    this.systemUserSearchLoading = true;
    const website = this.websites.find((website) => website.id === this.form.data.websiteId);
    if (!website) {
      this.$errorDialog.show('Website Not Found!');
      return;
    }

    this.systemUser = await this.systemUserRepository.findSystemUserById(website.details.unixUserId);
    if (!this.systemUser) {
      this.$errorDialog.show(`System User of website ${website.domain} not found!`);
      return;
    }

    this.form.data.systemUserId = this.systemUser.id;
    this.systemUserName = this.systemUser.name;

    this.systemUserSearchLoading = false;
  }
}
